/*
 * jQuery Unobtrusive Validation - Success Message
 * Source: https://stackoverflow.com/questions/7493512/jquery-unobtrusive-validation-in-net-mvc-3-showing-success-checkmark
 *
 * Takes care of setting the 'ValidMessage' set in campaign-pages
 */

const successMessage = () => {
  $(() => {
    const form = $('form');

    // return if not exists
    if (form[0] === undefined || $.data(form[0], 'validator') === undefined) {
      return;
    }

    const { settings } = $.data(form[0], 'validator');
    settings.onkeyup = false;
    settings.onfocusout = function handleOnFocusOut(element) {
      $(element).valid();
    };

    const oldSuccessFunction = settings.success;
    settings.validClass = 'valid';
    settings.success = function handleSuccess(label, element) {
      oldSuccessFunction(label);
      if ($(element).data('val-valid') !== undefined) {
        const container = $(`[data-valmsg-for='${$(element).attr('name')}']`);
        const id = `${$(element).attr('name')}-valid`;
        const html = `<span id='${id}'>${$(element).data('val-valid')}</span>`;
        container.html(html);
      }
    };
  });
};

export default successMessage;
